import React from 'react';

import FollowButton from '@components/FollowButton';
import UserAvatar, { AvatarSizes } from '@components/User/UserAvatar';
import { FollowType } from '@utils/backend-api/follow';
import type { ReporterLookup } from '@utils/backend-api/subscriber_directory';

interface ReporterCardProps {
  reporter: ReporterLookup;
}

const ReporterCard = ({ reporter }: ReporterCardProps) => {
  return (
    <article className="mt-32 flex flex-row gap-24">
      <UserAvatar
        customStyles="!rounded-full !bg-primary-pink"
        size={AvatarSizes.ExtraLarge}
        user={{
          picture_url: reporter.pictureUrl,
          name: reporter.name,
          username: reporter.username,
        }}
      />
      <div className="mt-24 flex flex-col items-start justify-start gap-24">
        <h4 className="m-0 font-suisse-screen text-headline-alt-sm font-normal">
          {reporter.name}{' '}
          {reporter?.jobTitle ? (
            <span className="mt-4 block text-byline-sm font-normal text-grayscale-gray">
              {reporter.jobTitle}
              {reporter?.company ? ` | ${reporter.company}` : ''}
            </span>
          ) : null}
        </h4>
        <FollowButton
          key={reporter.id}
          followeeId={reporter.identityId}
          followStatus={reporter.followStatus}
          followType={FollowType.Identity}
          name={reporter.name}
          username={reporter.username}
        />
      </div>
    </article>
  );
};

export default ReporterCard;
